module.exports = __webpack_public_path__ + "static/media/arrow-up.5b8e9a4a.svg";